import { Constants } from '../app.const';

export class MainConstants {

    public static basicConstans: any = Constants;

    public static baseUrl: string = Constants.baseUrl;
    public static apiUrl: string = Constants.baseUrl + Constants.apiVersioning;
    public static appUrl: string = Constants.appUrl;
    public static loginUrl: string = Constants.loginUrl;
    public static imageUrl: string = Constants.imageUrl;
    public static apiVersioning: string = Constants.apiVersioning;
    public static endPoint: string = Constants.endPoint;

    //ROUTES
    public static routeDashboard: string = Constants.routeDashboard;
    public static routeMy: string = Constants.routeMy;
    public static routeManage: string = Constants.routeManage;

    //LINK
    public static linkRedirectTo: string = '/' + Constants.linkMyDashboard;

    //ROUTE_DATA
    public static routeDataDashboard: string = 'Dashboard';
    public static routeDataMyDashboard: string = 'View My Dashboard';
    public static routeDataManageDashboard: string = 'Manage Dashboard';


    //LANGUAGE
    public static lanEn: string = "en";
    public static lanSw: string = "se";
    public static lanViewEn: string = "EN";
    public static lanViewSw: string = "SW";
    public static lanFlagEn: string = "../assets/flags/16/United-States.png";
    public static lanFlagSw: string = "../assets/flags/16/Sweden.png";

    public static LANG: string = "lang";

};


// WEBPACK FOOTER //
// ./src/app/modules/main.const.ts